import { render } from "./BaseChip.vue?vue&type=template&id=845c573e&scoped=true"
import script from "./BaseChip.vue?vue&type=script&lang=js"
export * from "./BaseChip.vue?vue&type=script&lang=js"

import "./BaseChip.vue?vue&type=style&index=0&id=845c573e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-845c573e"]])

export default __exports__